import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=289bf8d3&scoped=true&"
import script from "./HomeProducts.vue?vue&type=script&lang=js&"
export * from "./HomeProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&id=289bf8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bf8d3",
  null
  
)

export default component.exports